import * as Yup from 'yup'

export const issuerTierValidationSchema = Yup.object().shape({
  instrumentCode: Yup.string().required(),
  tier: Yup.string().required(),
})
